import { render, staticRenderFns } from "./whatsapp.vue?vue&type=template&id=0e168844&scoped=true&"
import script from "./whatsapp.vue?vue&type=script&lang=js&"
export * from "./whatsapp.vue?vue&type=script&lang=js&"
import style0 from "./whatsapp.vue?vue&type=style&index=0&id=0e168844&prod&scoped=true&lang=css&"
import style1 from "./whatsapp.vue?vue&type=style&index=1&id=0e168844&prod&scoped=true&lang=css&"
import style2 from "vuetify/dist/vuetify.min.css?vue&type=style&index=2&id=0e168844&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e168844",
  null
  
)

export default component.exports